/**
 * Search results component
 */

import React from "react";
import { Link } from "gatsby";
import PropertyCard from "../indexpage/propertycard";

const ResultsList = ({ properties, pageInfo }) => {
  let resultsFound = null;

  if (properties && pageInfo) {
    let count;
    if (pageInfo.totalCount === 0) {
      count = (
        <p className="text-lg">
          Mitään ei löytynyt. Haluatko nähdä{" "}
          <a className="link-fat-line" href="/huvilat/timanttikohteet/">
            timanttikohteet
          </a>{" "}
          tai{" "}
          <a className="link-fat-line" href="/huvilat/tarjoukset-last-minute/">
            alennuksia
          </a>
          ?
        </p>
      );
    } else {
      count = (
        <>
          <strong>{pageInfo.totalCount}</strong> kohde löytyi
        </>
      );
    }

    resultsFound = (
      <>
        <div className="d-flex justify-content-between align-items-center flex-column flex-md-row mb-4">
          <div>
            <p className="mb-3 mb-md-0">{count}</p>
          </div>
        </div>
        <div className="row">
          {properties.map(item => {
            return (
              <div key={item.id} className="col-sm-6 mb-5">
                <PropertyCard
                  title={item.property.marketing_name}
                  propertyType={item.property.property_types}
                  img={item.fields?.first_picture}
                  price={item.property.starting_price}
                  to={item.url}
                  occupancy={item.property.occupancy}
                  bedrooms={item.property.indoorfeatures.bedrooms}
                  bathrooms={item.property.indoorfeatures.bathrooms}
                  pool={item.property.pool}
                  diamondDeal={item.diamond_deal}
                  has_discounts={item.has_discounts}
                ></PropertyCard>
              </div>
            );
          })}
        </div>
      </>
    );
  }

  return resultsFound;
};

export default ResultsList;
